import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * Broadcasts the end of the current tenant/authentication context.
 *
 * A plain Subject is deliberate: work already in flight is cancelled, while
 * requests started for the newly selected tenant remain subscribed.
 */
@Injectable({
  providedIn: 'root',
})
export class TenantSessionService {
  private readonly invalidatedSubject = new Subject<void>();

  get invalidated$(): Observable<void> {
    return this.invalidatedSubject.asObservable();
  }

  invalidate(): void {
    this.invalidatedSubject.next();
  }
}
